'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.promiseDelay = void 0;
var truncateDelayMs_1 = require("./truncateDelayMs");
var promiseDelay = function (delayMs, val) {
    return new Promise(function (resolve) {
        setTimeout(function () {
            resolve(val);
        }, (0, truncateDelayMs_1.truncateDelayMs)(delayMs));
    });
};
exports.promiseDelay = promiseDelay;
